export type SmsPreviewPiece =
  | { kind: 'text'; value: string }
  | { kind: 'link'; value: string }
  | { kind: 'token'; value: string };

const PIECE_RE = /(\{\{[A-Za-z0-9_]+\}\}|https?:\/\/[^\s<]+|www\.[^\s<]+)/gi;
const TRAILING_PUNCTUATION = /[),.!?;:]+$/u;

/** Quebra o texto da prévia em trechos, links e variáveis ainda não resolvidas. */
export function splitSmsPreview(text: string): SmsPreviewPiece[] {
  if (!text) return [];
  const pieces: SmsPreviewPiece[] = [];
  let last = 0;

  for (const match of text.matchAll(PIECE_RE)) {
    const index = match.index ?? 0;
    if (index > last) pieces.push({ kind: 'text', value: text.slice(last, index) });
    const raw = match[0];
    if (raw.startsWith('{{')) {
      pieces.push({ kind: 'token', value: raw });
    } else {
      const trimmed = raw.replace(TRAILING_PUNCTUATION, '');
      const trailing = raw.slice(trimmed.length);
      if (trimmed) pieces.push({ kind: 'link', value: trimmed });
      if (trailing) pieces.push({ kind: 'text', value: trailing });
    }
    last = index + raw.length;
  }

  if (last < text.length) pieces.push({ kind: 'text', value: text.slice(last) });
  return pieces;
}

/** Número da conta como o celular mostra um remetente desconhecido. */
export function formatSmsSender(value: string): string {
  const trimmed = value.trim();
  if (!trimmed) return 'Número da conta';
  const digits = trimmed.replace(/\D/g, '');
  if (digits.length === 11 && digits.startsWith('1')) {
    return `+1 ${digits.slice(1, 4)} ${digits.slice(4, 7)} ${digits.slice(7)}`;
  }
  if (digits.length === 13 && digits.startsWith('55')) {
    return `+55 ${digits.slice(2, 4)} ${digits.slice(4, 9)}-${digits.slice(9)}`;
  }
  if (digits.length === 12 && digits.startsWith('55')) {
    return `+55 ${digits.slice(2, 4)} ${digits.slice(4, 8)}-${digits.slice(8)}`;
  }
  return trimmed;
}
